import { render, staticRenderFns } from "./company-document-form.vue?vue&type=template&id=ae834834&"
import script from "./company-document-form.vue?vue&type=script&lang=js&"
export * from "./company-document-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports